module.exports = __webpack_public_path__ + "img/banner1.963d95e.png";